import React, { useCallback, useEffect, useState } from 'react';
import { getKeySkills } from '../../services/api';
import QualificationForm from '../Qualification/QualificationForm';

const Form = ({ item, onChange, identifier = '', errors, setErrors, isDisabled = false }) => {
  const [keySkillList, setKeySkillList] = useState([]);

  const getKeySkillsData = useCallback(() => {
    (async () => {
      const keySkills = await getKeySkills();
      setKeySkillList(keySkills);
    })();
  }, [setKeySkillList]);

  useEffect(() => {
    getKeySkillsData();
  }, [getKeySkillsData]);

  return (
    <QualificationForm
      item={item}
      onChange={onChange}
      identifier={identifier}
      errors={errors}
      setErrors={setErrors}
      isDisabled={isDisabled}
      keySkillList={keySkillList}
      type="Certification"
      tooltipType="certifications"
    />
  );
};

export default Form;
